import { DetailviewService } from './DetailviewService';
import { serviceLogger } from '../Logger';
import { eventQBus as defaultEventQBus } from '@otto-ec/global-resources/event-q-bus';
import { DetailviewClient } from './DetailviewClient';

const log = serviceLogger.scope('detailview-app');

const debugEventBus = {
	on: (topicName: string) => {
		log.warn(`Registering on topic ${topicName} via debug eventBus.`);
	}
};

const eventQBus = defaultEventQBus ?? debugEventBus as never;

const detailviewService = new DetailviewService(eventQBus, new DetailviewClient());

detailviewService.registerEventListener().then(() => log.info('Registered event listener for up-detailview'));
